import { basicauthblog } from "./Credentials";

export function getBasicAuthHeader() {
  return {
    Authorization: `Basic ${btoa(`${basicauthblog.username}:${basicauthblog.password}`)}`,
  };
}
